
const customers = ['John Doe','Anna Smith','Robert Jones','Emily Wang','Mark Kim','Sarah Lee','Tom Hardy','Lina Park','Diego Reyes','Yuki Tanaka','Chris Hill','Nina Volkov','Ahmed Bashir','Fiona Reilly','Oliver Kane','Priya Verma','Jamie Morales','Sven Kowalski','Rachel Chen','Hana Kawasaki'];
const items = ['Aurora hoodie','Linen shirt','Trail sneakers','Canvas bag','Wireless earbuds','Pour-over set','Desk mat','Mech keyboard','Merino base layer','Coffee grinder'];
const channels = ['Web','Mobile','Email','Partner','Direct'];
const statuses = [['Paid','green'],['Processing','blue'],['Pending','yellow'],['Cancelled','red']];

const months = ['Jan','Feb','Mar','Apr'];
function rng(seed) { let s = seed; return () => { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
const r = rng(42);
const rows = [];
for (let i = 0; i < 50; i++) {
  const c = customers[Math.floor(r() * customers.length)];
  const it = items[Math.floor(r() * items.length)];
  const ch = channels[Math.floor(r() * channels.length)];
  const [stTxt, stCls] = statuses[Math.floor(r() * statuses.length)];
  const qty = 1 + Math.floor(r() * 5);
  const total = (29 + Math.floor(r() * 470));
  const month = months[Math.floor(r() * months.length)];
  const day = 1 + Math.floor(r() * 28);
  rows.push(`<tr>
    <td class="cell-mono">#${7800 + i}</td>
    <td class="cell-strong">${c}</td>
    <td>${it}</td>
    <td>${qty}</td>
    <td class="cell-strong">$${total}</td>
    <td>${ch}</td>
    <td><span class="status status-${stCls}">${stTxt}</span></td>
    <td>${month} ${day}, 2026</td>
  </tr>`);
}
document.getElementById('orders-tbody').innerHTML = rows.join('');
